import { convertJsonToFormData } from '../commonfunctions';
import { risapi, getAxiosConfig, getAPIFullUrl, handleApiError } from './risapi';

/**
 * Fetches the current user's profile data.
 * @param {function} callback The function to call with the response.
 */
export const getProfile = async (callback) => {
    try {
        const response = await risapi.get('/api/profile', getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

/**
 * Updates the user's profile data.
 * @param {FormData} formData The form data containing profile info and file.
 * @param {function} callback The function to call with the response.
 */
// export const updateProfile = async (formData, callback) => {
//     try {
//         const config = { ...getAxiosConfig(), headers: { 'Content-Type': 'multipart/form-data' } };
//         const response = await risapi.post('/api/profile', formData, config);
//         callback(response.data);
//     } catch (error) {
//         // Pass the whole error object so we can get validation errors
//         callback(error.response.data);
//     }
// };

export const updateProfile = async (data, callback) => {
    try {
        const formData = convertJsonToFormData(data);
        // We use post for file uploads
        const config = getAxiosConfig();
        config.headers['Content-Type'] = 'multipart/form-data';
        const response = await risapi.post('/api/profile', formData, config);
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};